import Vue from 'vue';
import Router from 'vue-router';

import Login from './views/Login';
import Main from './views/Layout';
import Homepage from './views/Homepage';

import Calendar from './views/Calendar';
import Notifications from './views/Notifications/Notifications';
import MyProfile from './views/SettingsTab/MyProfile';
import MyFriends from './views/SettingsTab/MyFriends';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            component: Main,
            children: [
                {
                    path: '',
                    component: Homepage
                },
                {
                    path: 'calendar',
                    component: Calendar
                },
                {
                    path: 'notifications',
                    component: Notifications
                },
                {
                    path: 'profile',
                    component: MyProfile
                },
                {
                    path: 'friends',
                    component: MyFriends
                }
            ]
        },
        {
            path: '/login',
            component: Login,
            meta: { noRequireAuthorization: true }
        }
    ]
});

router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.noRequireAuthorization)) {
        next();
    } else {
        if (to.path !== '/login') {
            AuthMiddleware.checkIsUserLogged()
                .then((returned)=>{
                    if(returned){
                        next();
                        setTimeout(()=>{
                            if(window.jsFrameworkAfterChangeRoute) window.jsFrameworkAfterChangeRoute();
                        },300);
                    }else{
                        next({
                            path: '/login',
                            query: {
                                redirect: to.fullPath ? to.fullPath : null,
                            }
                        });
                    }
                })
                .catch(()=>{
                    next({
                        path: '/login',
                        query: {
                            redirect: to.fullPath ? to.fullPath : null,
                        }
                    });
                });
        } else {
            next();
        }
    }
});

export default router;